import React from "react";
import { EventListPage } from "./eventListPage/eventListPage";
import { EventDetailsPage } from "./eventDetailsPage/eventDetailsPage";
import { SuccessPage } from "./successPage/successPage";
import { ClubcardPage } from "./clubcardPage/clubcardPage";
import { ClubcardSuccessPage } from "./clubcardSuccessPage/clubcardSuccessPage";
import { BrowserRouter, Route, Switch, withRouter } from "react-router-dom";
import { LogoutButton } from "./logout-button";
import { container } from "../services/container";
import { Translate } from "../services/translate";

declare const BASE_HREF: string;

export function App() {
  return (
    <>
      <BrowserRouter basename={BASE_HREF}>
        <>
          <UrlChangeHook />
          <Switch>
            <Route path="/:locale(eng)?" exact component={EventListPage} />
            <Route path="/:locale(eng)?/esemenyek/:id/:ticketTypeId?" component={EventDetailsPage} />
            <Route path="/:locale(eng)?/sikeres-foglalas" component={SuccessPage} />
            <Route path="/:locale(eng)?/clubcard" exact component={ClubcardPage} />
            <Route path="/:locale(eng)?/clubcard/sikeres-igenyles" component={ClubcardSuccessPage} />
          </Switch>
        </>
      </BrowserRouter>
      <LogoutButton />
    </>
  );
}

const UrlChangeHook = withRouter(function UrlChangeHookComponent(props) {
  const translate = container.get(Translate);

  translate.setLanguage(props.location.pathname.indexOf("/eng") === 0 ? "en" : "hu");

  return null;
});
